import React, { useContext } from "react";

export const Lotto99Context = React.createContext(null);
export const useLotto99 = () => useContext(Lotto99Context);